import { action } from 'mobx';

import { IInvoicePaymentModalStore } from './InvoicePaymentModalStore';
import { IModalStore, ModalType } from './ModalStore';
import { IPosPaymentStore } from './PosPaymentStore';
import { ISsoStore } from './SsoStore';
import UnsettledReceivablesStore from './UnsettledReceivablesStore';

export class InvoicePaymentStore {
  constructor(
    private unsettledReceivablesStore: UnsettledReceivablesStore,
    private invoicePaymentModalStore: IInvoicePaymentModalStore,
    private posPaymentStore: IPosPaymentStore,
    private ssoStore: ISsoStore,
    private modalStore: IModalStore
  ) {}

  @action
  public async makePayment(invoiceNumber: string): Promise<any> {
    await this.unsettledReceivablesStore.tryLoadUnsettledReceivables();
    const invoice = this.unsettledReceivablesStore.unpaidInvoice(invoiceNumber);
    if (this.ssoStore.isDealer) {
      return this.posPaymentStore.activatePaymentModal(invoice.unsettledAmount, invoice.referenceNumber);
    } else {
      this.invoicePaymentModalStore.activatePaymentModal(invoiceNumber, invoice.unsettledAmount, invoice.referenceNumber);
    }
  }

  @action
  public async payAll(): Promise<any> {
    if (this.ssoStore.isDealer) {
      await this.unsettledReceivablesStore.tryLoadUnsettledReceivables();
      this.posPaymentStore.activatePaymentModal(this.unsettledReceivablesStore.totalAmountToPay);
    } else {
      this.modalStore.openModal(ModalType.PayAllInvoicesPaymentModal);
    }
  }

  @action
  public makePrepayment(): void {
    if (this.ssoStore.isDealer) {
      this.posPaymentStore.activatePaymentModal(this.unsettledReceivablesStore.defaultPrepaymentAmount);
    } else {
      this.modalStore.openModal(ModalType.PrepaymentPaymentModal);
    }
  }
}
